const defaults = require('./defaults');

module.exports = {
  ...defaults,
  recaptchaRoot:
    'https://u67big8d6b.execute-api.ap-southeast-2.amazonaws.com/development',
  serviceApiRoot: 'https://development.services.lsapis.com.au',
  serviceGraphqlRoot: 'https://development.services.lsapis.com.au/graphql',
  bpm: {
    baseUrl: 'https://forbusiness.staging.localsearch.cloud',
  },
  hot: true,
  onlineClientUrlRoot: 'https://development.ls-www.localsearch.cloud',
  urlRoot: `http://localhost:${defaults.port}`,
  v2UrlRoot: 'https://development.ls-www.localsearch.cloud',
  b2bApiRoot: 'https://lsb2bstaging.wpengine.com',
  imageResizeRoot: 'https://images.development.ls-www.localsearch.cloud',
  token: {
    ...defaults.token,
    cookie: {
      domain: 'localhost',
    },
  },
  elastic: {
    nodes: [
      'http://10.41.7.29:9200',
      'http://10.41.8.157:9200',
      'http://10.41.10.196:9200',
    ],
    maxSize: 10,
    cacheControl: 'no-cache',
    indexes: {
      cms: 'cms',
    },
  },
  auth: {
    ...defaults.auth,
    redirectUri: `http://localhost:${defaults.port}/login-loader`,
    returnTo: `http://localhost:${defaults.port}`,
  },
  logger: {
    ...defaults.logger,
    console: {
      level: 'error',
    },
  },
};
